export class BasicCategoryInformation {
    public id: string;
    public name: string | null = '';

    constructor();
    constructor(categoryId: string, categoryName: string | null);
    constructor(categoryId?: string, categoryName?: string | null) {
        if (categoryId !== undefined) {
            this.id = categoryId;
            this.name = categoryName;
        }
    }
}